import { TYPE } from './actions';

export default function reducer(state = false) {
  return state;
}

export const selectSpoofing = state => state[TYPE];
